import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseOperationDeletedTemplates = [
  {
    id: '-116001',
    language: Language.EN,
    subject: 'Deletion of exceptional charge or service',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_OPERATION_DELETED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Dear {{listAllTenants lease}},</p>
        <p></p>
        <p>Concerns: {{getLeaseVariousType lvo language}} deletion on the lease located at <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>We have prematurely discontinued the {{getLeaseVariousType lvo language}} labeled: <strong>{{lvoLabel lvo language}}</strong>.</p>
        <p></p>
        <p>Kind regards,</p>
        <p></p>
        <p>{{accountSignature client}}</p>`,
  },
  {
    id: '-116002',
    language: Language.FR,
    subject: "Suppression d'une charge exceptionnelle ou d'un service",
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_OPERATION_DELETED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Cher/Chère {{listAllTenants lease}},</p>
        <p></p>
        {{#if (leaseVariousOperationIsService lvo)}}
        <p>Concerne: suppression d'un service relatif au bail sis <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>Nous avons mis fin anticipativement au service portant le libellé: <strong>{{lvoLabel lvo language}}</strong>.</p>
        {{else}}
        <p>Concerne: suppression d'une charge exceptionnelle relative au bail sis <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>Nous avons mis fin anticipativement à la charge exceptionnelle portant le libellé: <strong>{{lvoLabel lvo language}}</strong>.</p>
        {{/if}}
        <p></p>
        <p>Bien à vous,</p>
        <p></p>
        <p>{{accountSignature client}}</p>`,
  },
  {
    id: '-116003',
    language: Language.NL,
    subject: 'Afschaffing van uitzonderlijke last of dienst',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_OPERATION_DELETED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Geachte {{listAllTenants lease}},</p>
        <p></p>
        <p>Betreffende: afschaffing van een {{getLeaseVariousType lvo language}} op uw huurcontract gelegen te <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>Wij hebben de {{getLeaseVariousType lvo language}} met het label "<strong>{{lvoLabel lvo language}}</strong>" voortijdig beëindigd.</p>
        <p></p>
        <p>Met vriendelijke groeten,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-116004',
    language: Language.DE,
    subject: 'Löschung einer außergewöhnlichen Gebühr oder Dienstleistung',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_OPERATION_DELETED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Liebe/r {{listAllTenants lease}},</p>
        <p></p>
        {{#if (leaseVariousOperationIsService lvo)}}
        <p>Betreff: Löschung einer Dienstleistung für den Mietvertrag in <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        {{else}}
        <p>Betreff: Löschung einer außergewöhnlichen Gebühr für den Mietvertrag in <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        {{/if}}
        <p></p>
        <p>Wir haben die {{getLeaseVariousType lvo language}} mit der Bezeichnung "<strong>{{lvoLabel lvo language}}</strong>" vorzeitig beendet.</p>
        <p></p>
        <p>Mit freundlichen Grüßen,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
];
